var React = require('react');

function Se2 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 66.57C0 29.96 29.98 0 66.62 0h266.47c8.75 0 17.42 1.72 25.5 5.07 8.08 3.34 15.42 8.25 21.61 14.43s11.09 13.52 14.44 21.6a66.444 66.444 0 0 1 5.07 25.47z","fill":"#8fd8f7","key":0}),React.createElement("path",{"d":"M399.71 299.57H0c0 36.62 29.98 66.57 66.62 66.57h166.55V466l99.92-99.86c8.75 0 17.42-1.72 25.5-5.06a66.644 66.644 0 0 0 21.61-14.44 66.56 66.56 0 0 0 14.44-21.59 66.531 66.531 0 0 0 5.07-25.48z","fill":"#155397","key":1}),React.createElement("path",{"d":"M0 99.86h399.71v66.57H0z","fill":"#46a2d9","key":2}),React.createElement("path",{"d":"M0 199.71h399.71v66.58H0z","fill":"#2d6db5","key":3})]);
}

Se2.defaultProps = {"viewBox":"0 0 408.71239300659147 466","width":"36","height":"36"};

module.exports = Se2;

Se2.default = Se2;
